import {uniqueId} from 'lodash';
import React, {useCallback, useState} from 'react';

function useSVGBackgroundImage(props) {
    const {width = props.size, height = props.size, size, src} = props,
        [id] = useState(() => uniqueId('pattern-'));

    const Pattern = useCallback(() => {
        return (
            <pattern id={id} x="0" y="0" width="1" height="1">
                <image height={height} width={width} xlinkHref={src} preserveAspectRatio="xMidYMid meet"></image>
            </pattern>
        );
    }, [src, width, height]);

    const Def = useCallback(
        () => (
            <defs>
                <Pattern />
            </defs>
        ),
        [Pattern]
    );

    return [id, `url(#${id})`, Def, Pattern];
}

export default useSVGBackgroundImage;
